import { render, staticRenderFns } from "./Achievement-entrustment.vue?vue&type=template&id=6107254b&scoped=true&"
import script from "./Achievement-entrustment.vue?vue&type=script&lang=js&"
export * from "./Achievement-entrustment.vue?vue&type=script&lang=js&"
import style0 from "./Achievement-entrustment.vue?vue&type=style&index=0&id=6107254b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6107254b",
  null
  
)

export default component.exports